/* christina-lazy-dom.js — redukcja DOM storefrontu Christina.
 *
 * R7A5 (2026-08-04): plik nazywał się `christina-r6w3.js`. Numer rundy prac
 * nie mówi NIC o tym, co plik robi — nazwa modułu produkcyjnego mówi.
 * Zawartość przeniesiona 1:1, bez zmian logiki. Historia rundy R6-W3 została
 * w `D:\Christina Shopify\PDP-Redesign-2026-08\rollback\`, nie w nazwie assetu.
 * Konsument: snippets/cb-simgym-pack.liquid.
 *
 * 1) Wspoldzielony Quick View — jeden <quick-view id="CbQuickView"> na strone
 *    zamiast osobnego modala w kazdej karcie produktu. Kazdy przycisk karty ma
 *    aria-controls="CbQuickView" oraz data-cbqv-url / data-cbqv-label; ten skrypt
 *    ustawia data-product-url i aria-label modala ZANIM zadziala handler motywu.
 * 2) <template data-cb-lazy="hover"> — materializowany przy pointerover /
 *    pointerdown / focusin / click / keydown w obrebie [data-cb-lazy-root]
 *    (glebokie panele mega menu) albo w obrebie elementu wskazanego przez
 *    data-cb-lazy-for="<id>" i wszystkich [aria-controls="<id>"]
 *    (mobilna szuflada menu, mini-koszyk).
 * 3) <template data-cb-lazy="view"> — IntersectionObserver, rootMargin 600 px
 *    (stopka: lista ikon platnosci).
 *
 * Bezpieczenstwo: kazdy szablon z data-cb-lazy-for, ktory pojawi sie PO parsowaniu
 * dokumentu (Section Rendering API — np. po dodaniu do koszyka) jest materializowany
 * natychmiast, w tym samym mikrotasku, wiec szuflada nigdy nie otwiera sie pusta.
 * Dostepnosc: zaden element interaktywny nie znika — panele powstaja przed
 * otwarciem, a linki najwyzszego poziomu zostaja w HTML serwera.
 */
(function () {
  'use strict';

  var QV_ID = 'CbQuickView';

  /* ------------------------------------------------------------------ utils */

  function materialize(tpl) {
    if (!tpl || tpl.tagName !== 'TEMPLATE' || !tpl.parentNode) return false;
    var frag = tpl.content ? tpl.content.cloneNode(true) : null;
    if (!frag) return false;
    tpl.parentNode.replaceChild(frag, tpl);
    return true;
  }

  function materializeIn(root) {
    if (!root) return 0;
    var n = 0;
    if (root.tagName === 'TEMPLATE') return materialize(root) ? 1 : 0;
    if (!root.querySelectorAll) return 0;
    var list = root.querySelectorAll('template[data-cb-lazy]');
    for (var i = 0; i < list.length; i++) {
      if (materialize(list[i])) n++;
    }
    return n;
  }

  function toElement(node) {
    var el = node;
    while (el && el.nodeType !== 1) el = el.parentNode;
    return el;
  }

  function closestEl(node, sel) {
    var el = toElement(node);
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ------------------------------------------------- 1. shared quick view */

  var qvEl = null;
  function qv() {
    if (!qvEl || !qvEl.isConnected) qvEl = document.getElementById(QV_ID);
    return qvEl;
  }

  function primeQuickView(event) {
    var trigger = closestEl(event.target, '[data-cbqv-url]');
    if (!trigger) return;
    var modal = qv();
    if (!modal) return;
    var url = trigger.getAttribute('data-cbqv-url');
    if (url) modal.setAttribute('data-product-url', url);
    var label = trigger.getAttribute('data-cbqv-label');
    if (label) modal.setAttribute('aria-label', label);
  }

  /* Po podmianie siatki produktow (filtry / doladowanie) modal musi przepiac
     sluchacze na nowe przyciski. ModalElement wiaze je w connectedCallback,
     wiec wystarczy odlaczyc i podlaczyc element ponownie. */
  var rebindTimer = null;
  function scheduleRebind() {
    if (rebindTimer) clearTimeout(rebindTimer);
    rebindTimer = setTimeout(function () {
      rebindTimer = null;
      var modal = qv();
      if (!modal || modal.hasAttribute('open') || !modal.parentNode) return;
      var parent = modal.parentNode;
      var next = modal.nextSibling;
      parent.removeChild(modal);
      parent.insertBefore(modal, next);
    }, 150);
  }

  /* ------------------------------------------------ 2. leniwe panele (UI) */

  var entries = [];

  function collectEntries() {
    entries = [];
    var tpls = document.querySelectorAll('template[data-cb-lazy]');
    for (var i = 0; i < tpls.length; i++) {
      var tpl = tpls[i];
      if (tpl.getAttribute('data-cb-lazy') === 'view') continue;
      var host = closestEl(tpl, '[data-cb-lazy-root]') || tpl.parentElement;
      if (!host) continue;
      var targets = [host];
      var forId = tpl.getAttribute('data-cb-lazy-for');
      if (forId) {
        var owner = document.getElementById(forId);
        if (owner) targets.push(owner);
        var controls = document.querySelectorAll('[aria-controls="' + forId + '"]');
        for (var j = 0; j < controls.length; j++) targets.push(controls[j]);
      }
      entries.push({ targets: targets, host: host });
    }
  }

  function onIntent(event) {
    if (!entries.length) return;
    var node = toElement(event.target);
    if (!node) return;
    for (var i = entries.length - 1; i >= 0; i--) {
      var entry = entries[i];
      var hit = false;
      for (var j = 0; j < entry.targets.length; j++) {
        var t = entry.targets[j];
        if (t === node || t.contains(node)) { hit = true; break; }
      }
      if (hit) {
        materializeIn(entry.host);
        entries.splice(i, 1);
      }
    }
  }

  /* ------------------------------------------ 3. leniwe panele (viewport) */

  function initViewLazy() {
    var tpls = document.querySelectorAll('template[data-cb-lazy="view"]');
    if (!tpls.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var k = 0; k < tpls.length; k++) materialize(tpls[k]);
      return;
    }
    var io = new IntersectionObserver(function (records, obs) {
      for (var i = 0; i < records.length; i++) {
        if (!records[i].isIntersecting) continue;
        obs.unobserve(records[i].target);
        materializeIn(records[i].target);
      }
    }, { rootMargin: '600px 0px' });
    for (var j = 0; j < tpls.length; j++) {
      var host = tpls[j].parentElement;
      if (host) io.observe(host);
    }
  }

  /* --------------------------------------------------- 4. obserwator DOM */

  function watchDom() {
    if (!window.MutationObserver) return;
    var body = document.body;
    if (!body) return;
    new MutationObserver(function (records) {
      var refreshEntries = false;
      var rebind = false;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          /* Szablony wstrzykniete po parsowaniu (Section Rendering API) —
             materializuj natychmiast, bo pochodza z juz otwieranego widoku. */
          if (node.matches && node.matches('template[data-cb-lazy-for]')) {
            materialize(node);
          } else if (node.querySelector && node.querySelector('template[data-cb-lazy-for]')) {
            var inner = node.querySelectorAll('template[data-cb-lazy-for]');
            for (var k = 0; k < inner.length; k++) materialize(inner[k]);
          }
          if (node.matches && (node.matches('[data-cbqv-url]') || node.querySelector('[data-cbqv-url]'))) {
            rebind = true;
          }
          if (node.matches && (node.matches('template[data-cb-lazy]') || node.querySelector('template[data-cb-lazy]'))) {
            refreshEntries = true;
          }
        }
      }
      if (rebind) scheduleRebind();
      if (refreshEntries) collectEntries();
    }).observe(body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------- listeners */

  document.addEventListener('pointerdown', primeQuickView, true);
  document.addEventListener('mousedown', primeQuickView, true);
  document.addEventListener('touchstart', primeQuickView, { capture: true, passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') primeQuickView(event);
  }, true);
  document.addEventListener('click', primeQuickView, true);

  document.addEventListener('pointerover', onIntent, true);
  document.addEventListener('pointerdown', onIntent, true);
  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('click', onIntent, true);
  document.addEventListener('keydown', onIntent, true);
  document.addEventListener('cart:refresh', function () { materializeIn(document.getElementById('CartDrawer')); });
  document.addEventListener('cart:bundled-sections', function () { materializeIn(document.getElementById('CartDrawer')); });

  /* ------------------------------------------------------------- bootstrap */

  function init() {
    collectEntries();
    initViewLazy();
    watchDom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
